import { render, staticRenderFns } from "./ViewStyleConfigInput.vue?vue&type=template&id=2dacedc2&scoped=true&"
import script from "./ViewStyleConfigInput.vue?vue&type=script&lang=js&"
export * from "./ViewStyleConfigInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dacedc2",
  null
  
)

export default component.exports